module.exports = __webpack_public_path__ + "img/img_review_event_pop_02.59388775.png";